import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UserManagementService } from 'src/app/shared/userManagement.service';
import * as UserActions from './users.actions';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class UsersEffects {
    constructor(private actions$: Actions, private userManagementService: UserManagementService) {}

    loadUsers$ = createEffect(() =>
        this.actions$.pipe(
        ofType(UserActions.loadUsers),
        mergeMap(() => {
            return this.userManagementService.getUsers().pipe(
            map(users => UserActions.loadUsersSuccess({ users })),
            catchError(error => of(UserActions.loadUsersFailure({ error })))
            );
        })
        )
    );

}